/** The 2 px focus ring of spec §14, on keyboard focus only. */
export const focusRing = 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus';

/**
 * What every round icon trigger of the chrome shares (the toolbar's menus, the main menu, the context bar's popovers):
 * the shape, the pressed feel, the focus ring and the tint while its popup is open. Each adds its own size and hover fill
 * (`cn(iconTriggerClass, 'h-10 hover:bg-chrome-hover pointer-coarse:h-11')`).
 */
export const iconTriggerClass = `inline-flex shrink-0 items-center justify-center rounded-full text-fg-muted os-press hover:text-fg ${focusRing} data-[popup-open]:bg-surface-2 data-[popup-open]:text-fg`;

/**
 * Base UI's `finalFocus` for a popup that animates out (P5g): the focus goes back to the trigger once the exit ends,
 * unless the person already moved it elsewhere meanwhile (a tap on the canvas that opened an editor), which it keeps.
 * `opener` (P12a): what had the focus when a mounted-open popup appeared. Base UI takes for "the trigger" what had the
 * focus when its focus manager started, which is already the field an `autoFocus` focused on opening.
 */
export function returnFocusUnlessMoved(popup: { readonly current: HTMLElement | null }, opener?: Element | null): () => boolean | HTMLElement {
  return () => {
    const active = document.activeElement;
    const back = !active || active === document.body || !!popup.current?.contains(active);
    if (back && opener instanceof HTMLElement && opener !== document.body && opener.isConnected) return opener;
    return back;
  };
}
